/* ============================================================
   Pixkom Aktionen / Deals page (Task 6.2) — countdown, stock bar,
   bundle "Set in den Korb".

   - Countdown: [data-deal-countdown] ticks every second toward
     data-deal-end (ISO-ish "YYYY-MM-DDTHH:MM"); blank/invalid/past
     → end of the current day (23:59:59, shopper-local) so a "Deal
     des Tages" always counts toward midnight. Two-digit padded.
   - Stock bar: [data-stock-bar] gets its fill width from
     data-stock-left / data-stock-total (also usable standalone).
   - Bundles: [data-pk-bundle-add] adds every id in
     data-variant-ids sequentially via window.pkCart.add.
     [data-pk-deal-add] adds its single data-variant-id.
   Note: prices shown on the page are display-only — the actual
   discounts live as automatic discounts in the Shopify Admin.
   ============================================================ */
(function () {
  'use strict';

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* ---------- countdown ---------- */

  function endOfToday() {
    var d = new Date();
    d.setHours(23, 59, 59, 999);
    return d;
  }

  function parseEnd(raw) {
    if (!raw) return null;
    var t = new Date(raw);
    return isNaN(t.getTime()) ? null : t;
  }

  function initCountdown(root) {
    if (root.dataset.pkCountdownReady === 'true') return;
    root.dataset.pkCountdownReady = 'true';

    var hEl = root.querySelector('[data-cd-h]');
    var mEl = root.querySelector('[data-cd-m]');
    var sEl = root.querySelector('[data-cd-s]');
    if (!hEl || !mEl || !sEl) return;

    var explicitEnd = parseEnd(root.getAttribute('data-deal-end'));
    var end = explicitEnd || endOfToday();

    function tick() {
      var diff = end.getTime() - new Date().getTime();
      if (diff <= 0) {
        if (explicitEnd) {
          // Fixed deadline reached: freeze at zero.
          diff = 0;
        } else {
          // Daily deal rolled over midnight: aim at the new day's end.
          end = endOfToday();
          diff = Math.max(0, end.getTime() - new Date().getTime());
        }
      }
      var totalSec = Math.floor(diff / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      hEl.textContent = pad2(h);
      mEl.textContent = pad2(m);
      sEl.textContent = pad2(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---------- stock bar ---------- */

  function initStockBar(bar) {
    var fill = bar.querySelector('[data-stock-fill]');
    if (!fill) return;
    var left = parseInt(bar.getAttribute('data-stock-left'), 10);
    var total = parseInt(bar.getAttribute('data-stock-total'), 10);
    if (isNaN(left) || isNaN(total) || total <= 0) return;
    var pct = Math.max(0, Math.min(100, (left / total) * 100));
    fill.style.width = pct + '%';
  }

  /* ---------- add-to-cart (deal + bundles) ---------- */

  function canAdd() {
    return window.pkCart && typeof window.pkCart.add === 'function';
  }

  function addSequentially(ids) {
    // One item after the other — Shopify's cart API dislikes
    // concurrent mutations, and pkCart re-renders sections per call.
    return ids.reduce(function (chain, id) {
      return chain.then(function () {
        return window.pkCart.add(id, 1);
      });
    }, Promise.resolve());
  }

  function parseIds(raw) {
    return (raw || '')
      .split(',')
      .map(function (s) { return parseInt(s.trim(), 10); })
      .filter(function (n) { return !isNaN(n) && n > 0; });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-pk-bundle-add], [data-pk-deal-add]');
    if (!btn || btn.classList.contains('is-adding')) return;

    var ids = btn.hasAttribute('data-pk-bundle-add')
      ? parseIds(btn.getAttribute('data-variant-ids'))
      : parseIds(btn.getAttribute('data-variant-id'));
    if (!ids.length) return;

    event.preventDefault();

    if (!canAdd()) {
      // No cart JS (e.g. static harness): fall back to the product page.
      var href = btn.getAttribute('data-fallback-url');
      if (href) window.location.href = href;
      return;
    }

    btn.classList.add('is-adding');
    addSequentially(ids)
      .catch(function () { /* pkCart already announces failures */ })
      .then(function () {
        btn.classList.remove('is-adding');
      });
  });

  /* ---------- boot ---------- */

  function init() {
    document.querySelectorAll('[data-deal-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-stock-bar]').forEach(initStockBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-init after section reloads.
  document.addEventListener('shopify:section:load', init);
})();
